import { TableColumnInfo, TableRowInfo } from "../components/NSTable";
import { BaseColumnFormatter } from "./BaseColumnFormatter";

export class ForeColorFormatter extends BaseColumnFormatter
{
    private formatter: BaseColumnFormatter;
    private colors: { [value: string]: string }
    constructor(formatter: BaseColumnFormatter, colors: { [value: string]: string }, width?: string)
    {
        super();
        this.formatter = formatter;
        this.colors = colors;
        let w = width ?? formatter.width;
        if (w)
            this.width = w;
    }
    override format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean): any
    {
        let formatted = this.formatter.format(value, column, row, printable);
        if (!printable)
            if (this.colors[value])
                return <span style={{ color: this.colors[value], fontWeight: "bold" }}> {formatted} </span>;
        return formatted;
    }
}